import React, { useEffect, useState } from "react"
import MenuItemsList from "./Menu"
import { TabContent, TabPane } from 'reactstrap'
import { useSelector } from "react-redux"
const MainContent  = (props) => {
    const MenuItems = MenuItemsList()
    const [tabs, setTabs] = useState([])
    const [component, setComponent] = useState({})
    let activeTab = useSelector(state => state.SidebarActiveTab);
    let dynamicTabs = useSelector(state => state.SidebarList);
    useEffect(() => {
        setTabs(dynamicTabs)
        const activeComponent = MenuItems.filter((tab, key) => {
            return tab.right === true
        })[0]
        setComponent(activeComponent)
    },[activeTab])
    return (
        <>
            {tabs.length > 0 ? (
                <>
                    <TabContent activeTab={activeTab}>
                        {tabs &&
                            tabs.map((item) => {
                                return (
                                    <React.Fragment key={item.key}>
                                        <TabPane tabId={item.key}>{item.component}</TabPane>
                                    </React.Fragment>
                                )
                            })}
                    </TabContent>
                </>
            ) : (
                <TabContent activeTab={component?.key}>
                    <React.Fragment key={component?.key}>
                        <TabPane tabId={component?.key}>{component?.component}</TabPane>
                    </React.Fragment>
                </TabContent>
            )}
        </>
    )
}

export default MainContent 